import { render, staticRenderFns } from "./ProcessEdit.vue?vue&type=template&id=5c32347b&scoped=true"
import script from "./ProcessEdit.vue?vue&type=script&lang=js"
export * from "./ProcessEdit.vue?vue&type=script&lang=js"
import style0 from "./ProcessEdit.vue?vue&type=style&index=0&id=5c32347b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32347b",
  null
  
)

export default component.exports